module.exports = __webpack_public_path__ + "img/20191216162146360截图20191216105419620.4f70d0dc.jpg";